import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Panel, Hr, Row, Margin, Table, Text } from 'shared/components'

import { SelectorComponent } from './components/selector'

const BeneficiariesComponent = ({
  columns,
  favoriteColumns,
  loadAthletes,
  loadFavoriteAthlete,
}) => {
  const [isFavorite, setIsFavorite] = useState(true)
  const onClick = () => {
    setIsFavorite(!isFavorite)
  }
  return (
    <Panel>
      <Text as="h1" size={18} bold>
        Tournaments
      </Text>
      <Margin tb={3}>
        <Hr width="full" />
      </Margin>
      <Margin left={2} bottom={3}>
        <Row>
          <SelectorComponent isFavorite={isFavorite} onClick={onClick} />
        </Row>
      </Margin>

      {isFavorite ? (
        <Table
          id="favorite-athlete-table"
          columns={favoriteColumns}
          loadData={loadFavoriteAthlete}
        />
      ) : (
        <>
          <Table id="athlete-table" columns={columns} loadData={loadAthletes} />
        </>
      )}
    </Panel>
  )
}

BeneficiariesComponent.propTypes = {
  query: PropTypes.any,
  columns: PropTypes.arrayOf(PropTypes.shape()),
  favoriteColumns: PropTypes.arrayOf(PropTypes.shape()),
  loadAthletes: PropTypes.func,
  loadFavoriteAthlete: PropTypes.func,
}

export default BeneficiariesComponent
